import { Tag } from '@factorialco/deprecated-design-system'
import { AtsCandidateTagItemFragment } from 'generated/resources/graphql'

import { useRemoveTagFromCandidate } from 'modules/ats/hooks/candidates/useRemoveTagFromCandidate'

interface Props {
  tag: AtsCandidateTagItemFragment
  candidateId: number
}

export const CandidateTag = ({ candidateId, tag }: Props) => {
  const { loading, removeTag } = useRemoveTagFromCandidate()

  return (
    <Tag
      rightItem="close"
      disabled={loading}
      onClose={() => removeTag({ atsCandidateId: candidateId, atsTagId: tag.id })}
    >
      {tag.name}
    </Tag>
  )
}
